






import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import VueRouter from 'vue-router'

@Component
export default class AlertBarComponent extends Vue {
  @Prop({ default: "info" })
  type!: string

  @Prop({ default: "" })
  message!: string

  @PropSync("isVisible", { type: Boolean, default: false, required: true })
  syncIsVisible!: boolean

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    this.syncIsVisible = false
    next()
  }
}
